// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"39fe5e22","551":"9c744230","750":"419617d7","796":"cd7f1d9f","842":"80632781"}[chunkId] + ".chunk.js";
};